import PL from './pl/common.data';
import EN_GB from './uk/common.data';
import UK from './ua/common.data';
import DE from './de/common.data';
import CS from './cs/common.data';
import RO from './ro/common.data';
import HU from './hu/common.data';
import SK from './sk/common.data';
import BG from './bg/common.data';
import FR from './fr/common.data';
import IT from './it/common.data';
import ES from './es/common.data';
import NL from './nl/common.data';
import SV from './sv/common.data';
import PT from './pt/common.data';
import DA from './da/common.data';
import FI from './fi/common.data';


export default {
    "pl": PL,
    "en-GB": EN_GB,
    "uk": UK,
    "de": DE,
    "cs": CS,
    "ro": RO,
    "hu": HU,
    "sk": SK,
    "bg": BG,
    "fr": FR,
    "it": IT,
    "es": ES,
    "nl": NL,
    "sv": SV,
    "pt": PT,
    "da": DA,
    "fi": FI
}